export default {
    apiUrl: 'https://api.vwadkv.startupblitz.de',
    apiKey: 'Kjay9stbWG0KZkBdrjCorZiynfh22LHabqcNodu3lSGLku8Nz1G1QPvKcUP0We7DrSeUZ0SFb2XiX4xoHGKcGLhjO2eu7b4CSpFqqDPHqftnGnN9zwsQKrmjk2KQdcI9',
    formId: 'dd0bf7aad19d8d8b62b7c7d303535675'
}
